'use client'
import { Product, Variant } from '@/payload-types'
import { useSearchParams } from 'next/navigation'
import { useMemo } from 'react'

import { RestockDialog } from './RestockDialog'

type Props = {
  product: Product
}

export const StockIndicator: React.FC<Props> = ({ product }) => {
  const searchParams = useSearchParams()

  const variants = product.variants?.docs || []

  const selectedVariant = useMemo<Variant | undefined>(() => {
    if (product.enableVariants && variants.length) {
      const variantId = searchParams.get('variant')
      const validVariant = variants.find((variant) => {
        if (typeof variant === 'object') {
          return String(variant.id) === variantId
        }
        return String(variant) === variantId
      })

      if (validVariant && typeof validVariant === 'object') {
        return validVariant
      }
    }

    return undefined
  }, [product.enableVariants, searchParams, variants])

  const stockQuantity = useMemo(() => {
    if (product.enableVariants) {
      if (selectedVariant) {
        return selectedVariant.inventory || 0
      }
    }
    return product.inventory || 0
  }, [product.enableVariants, selectedVariant, product.inventory])

  if (product.enableVariants && !selectedVariant) {
    return null
  }

  const soldOut = !stockQuantity || stockQuantity <= 0

  return (
    <div className="flex flex-col gap-3">
      <div className="font-display text-sm uppercase tracking-wide text-ink/60">
        {stockQuantity < 10 && stockQuantity > 0 && <p>Осталось {stockQuantity} шт.</p>}
        {soldOut && <p>Нет в наличии</p>}
      </div>
      {soldOut && (
        <RestockDialog productID={product.id} variantID={selectedVariant?.id} title={selectedVariant?.title ?? product.title} />
      )}
    </div>
  )
}
